import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ParksService} from '@app/app/shared/services/parks.service';
import {ThingTasksInterface} from '@app/app/shared/interfaces/thing/thing-tasks.interface';
import * as moment from 'moment';
import {CommandsService} from '@app/app/shared/services/commands.service';
import * as uuid from 'uuid';

@Component({
  templateUrl: './park-task-form.html',
  selector: 'park-task-form',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .gray-modal .modal-content {
      text-align: center;
      background-color: #EEE;
    }
  `, `
    ngb-datepicker.dropdown-menu {
      width: auto;
    }
  `]
})
export class ParkTaskFormComponent implements OnInit {
  constructor(private formBuilder: FormBuilder,
              private parksService: ParksService,
              private modalService: NgbModal,
              private comm: CommandsService) {
  }

  @Input() private parkId;
  @Input() private id;
  @Input() public mode;
  @Input() public task: ThingTasksInterface;
  @Input() public taskId: string | null;

  public taskForm: FormGroup = new FormGroup({
    title: new FormControl('', Validators.required),
    dueDate: new FormControl('', Validators.required),
    description: new FormControl(),
    priority: new FormControl('', Validators.required),
    recurrence: new FormControl('', Validators.required),
    recurrencePeriod: new FormControl('', [Validators.required, Validators.min(1), Validators.max(999)]),
  });

  public repeatCycles = [
    {id: '0', value: 'Day'},
    {id: '1', value: 'Week'},
    {id: '2', value: 'Month'},
    {id: '3', value: 'Year'}
  ];
  public minDate;
  private modalReference: any;
  private method = 'add';
  public isValid = null;
  public inProgress = false;

  /**
   * Open modal window with form for create/edit task
   * @param content
   */
  open(content) {
    this.modalReference = this.modalService.open(content, {windowClass: 'gray-modal'});
  }

  /**
   * Send queries after submitting form
   */
  public onFormSubmit() {
    let params = {};

    this.isValid = this.taskForm.valid;

    if (this.taskForm.valid) {
      const d = this.taskForm.value.dueDate.year + '-' + this.taskForm.value.dueDate.month + '-' + this.taskForm.value.dueDate.day;
      const dueDate = moment(d, 'YYYY-MM-DD').format('YYYY-MM-DD');
      const recurrence = Number(this.taskForm.value.recurrence);
      const recurrence_period = Number(this.taskForm.value.recurrencePeriod);
      const priority = Number(this.taskForm.value.priority);

      if (this.method === 'add') {
        params = {
          add: {
            id: uuid.v4(),
            title: this.taskForm.value.title,
            description: this.taskForm.value.description,
            due_date: dueDate,
            recurrence: recurrence,
            recurrence_period: recurrence_period,
            priority: priority,
          }
        };
      } else if (this.method === 'edit') {
        params = {
          edit: {
            id: this.taskId,
            title: this.taskForm.value.title,
            description: this.taskForm.value.description,
            due_date: dueDate,
            recurrence: recurrence,
            recurrence_period: recurrence_period,
            priority: priority,
          }
        };
      }

      this.inProgress = true;

      this.comm.createOrEditTask(this.parkId, this.id, params).then((res) => {
        this.inProgress = false;

        if (this.method === 'add') {
          this.resetForm();
        }

        if (this.modalReference) {
          this.modalReference.close();
        }
      }).catch(() => {
        this.inProgress = false;
      });
    }
  }

  deleteTask() {
    if (confirm(`Are you sure you want to to delete '${this.task.title}' task?`)) {
      this.comm.deleteTask(this.parkId, this.id, this.taskId).then((res) => {
        this.modalReference.close();
      }).catch((err) => {
        // TODO
      });
    }
  }

  private resetForm() {
    const today = new Date();

    this.minDate = {year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate()};

    this.taskForm.setValue({
      title: '',
      description: '',
      dueDate: this.minDate,
      recurrence: '0',
      recurrencePeriod: 1,
      priority: '0',
    });
  }

  ngOnInit() {
    const today = new Date();

    if (typeof this.task !== 'undefined') {
      this.method = 'edit';
      this.minDate = {year: today.getFullYear() - 1, month: today.getMonth(), day: today.getDate()};

      const dueDate = moment(this.task.dueDate, 'YYYY-MM-DD').toDate();

      this.taskForm.setValue({
        title: this.task.title || '',
        description: this.task.description || '',
        dueDate: {day: dueDate.getDate(), month: dueDate.getMonth() + 1, year: dueDate.getFullYear()},
        recurrence: this.task.recurrence || '0',
        recurrencePeriod: this.task.recurrencePeriod || 1,
        priority: this.task.priority.toString() || '0',
      });
    } else {
      this.method = 'add';
      this.resetForm();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/park-task-form/park-task-form.component.ts